export const FILING_TABS = [
  { value: 'main', label: 'Main', style: 'filingMain' },
  { value: 'amended', label: 'Amended', style: 'filingAmended' },
  { value: 'extension', label: 'Extension', style: 'filingExtension' },
];

export const FEDERAL_FILING_STATUSES = [
  { code: 'A', title: 'Fed Accepted' },
  { code: 'Y', title: 'Pending - At IRS' },
  { code: 'W', title: 'Pending - Received' },
  { code: 'Q', title: 'Queued' },
  { code: 'R', title: 'Fed Rejected' },
  { code: 'G', title: 'Refused' },
];

export const SUBMITTED_RETURN_STATUS_KEYS = [
  'Acked',
  'Chk Rdy',
  'Queued',
  'Received',
  'Refused',
  'Pending',
  'Rejected',
  'StReject',
];
